import { render, staticRenderFns } from "./ConvergePassword.vue?vue&type=template&id=b1ee6c04&"
import script from "./ConvergePassword.vue?vue&type=script&lang=ts&"
export * from "./ConvergePassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports